<template>
   <div class="crud-wrapper">
      <crud :form-component="EmployeeForm" :grid-columns="gridColumns"
            :pageFilters="pageFilters" obj="employee">
      </crud>
   </div>
</template>

<script>
   import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
   import EmployeeForm from './EmployeeForm';

   export default PageClass.extend({
      name: 'employees',

      data () {
         return {
            EmployeeForm,
            gridColumns: [
               {
                  dataField: 'storeName',
                  caption: 'Empresa',
                  width: 120,
                  groupIndex: 0
               },
               {
                  dataField: 'avatar',
                  caption: '',
                  width: 70,
                  cellTemplate: (element, info) => {
                     let media = '/static/images/no-avatar.jpg';
                     let avatar = info.data.avatar;

                     console.log('cell template', avatar, info.data);

                     if (avatar) {
                        media = this.$config.imageUri(avatar, 'avatar');
                     }

                     $(`<div style="background: url('${media}') no-repeat center center; background-size: cover; border-radius: 100%; height: 36px; width: 36px; margin-left:10px;"></div>`)
                        .appendTo(element);


                  }
               },
               {
                  dataField: 'name',
                  caption: 'Nome',
                  minWidth: 150
               },
               {
                  dataField: 'roleName',
                  caption: 'Perfil',
                  minWidth: 120
               },
               {
                  dataField: 'cellName',
                  caption: 'Célula',
                  minWidth: 100
               },
               {
                  dataField: 'voipExt',
                  caption: 'Ramal Voip',
                  width: 90
               },
               {
                  dataField: 'mobileNumber',
                  caption: 'Fone',
                  minWidth: 110
               },
               {
                  dataField: 'birth',
                  caption: 'Nascimento',
                  dataType: 'date',
                  format: 'dd/MM/yyyy',
                  width: 110
               },
               {
                  dataField: 'city',
                  caption: 'Cidade'
               },
               {
                  dataField: 'state',
                  caption: 'Estado',
                  width: 90
               }
            ]
         };
      },

      created () {

         /*if (!this.hasPageFilters) {
            this.createPageFilters([
               {field: 'exchangeStatusId', value: null, label: ''},
               {field: 'hasDebit', value: false, label: ''}
            ]);

            //Defining default filters
            // this.setPageFilter('dateRange', [this.$util.dateRange.today.start(), this.$util.dateRange.today.start()], 'Em {0}'.format(this.$util.dateRange.today.start('MMM/DD/YYYY')));
         }*/

      }


   });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Employees.vue